module.exports = __webpack_public_path__ + "img/app_icon.0cf7d6dc.png";